(function() {
    function waitForFlickityGlobal(callback, attempts) {
      if (typeof Flickity !== 'undefined') {
        callback();
      } else if ((attempts || 0) < 40) {
        setTimeout(function() { waitForFlickityGlobal(callback, (attempts || 0) + 1); }, 100);
      }
    }
  
    function initRelatedRecipesProgress() {
      var blocks = document.querySelectorAll('.related-recipes-block');
      
      blocks.forEach(function(block, blockIndex) {
        if (block.dataset.progressInitialized) {
          return;
        }
        block.dataset.progressInitialized = 'true';
        var carousel = block.querySelector('.upsell__carousel');
        if (!carousel) {
          return;
        }
        var progressBar = block.querySelector('.carousel-progress');
        
        // Only proceed if there are multiple cells
        var cells = carousel.querySelectorAll('.upsell__carousel__cell');
        if (cells.length <= 1 && !progressBar) {
          return; // Don't need carousel for single item
        }
        
        // Hide Flickity prev/next arrows for this carousel (CSS fallback)
        var flickityArrows = block.querySelectorAll('.flickity-prev-next-button');
        flickityArrows.forEach(function(btn) { btn.style.display = 'none'; });
        function waitForFlickityInit(attempts) {
          if (!carousel) {
            return;
          }
          if (typeof Flickity === 'undefined') {
            if (attempts < 40) {
              setTimeout(function() { waitForFlickityInit(attempts + 1); }, 100);
            }
            return;
          }
          var flkty = Flickity.data(carousel);
          if (!flkty) {
            try {
              // Ensure container has width
              var offsetWidth = carousel.offsetWidth;
              var clientWidth = carousel.clientWidth;
              if (offsetWidth === 0 && clientWidth === 0) {
                // Wait for container to have dimensions
                if (attempts < 40) {
                  setTimeout(function() { waitForFlickityInit(attempts + 1); }, 100);
                }
                return;
              }
              
              // Calculate proper cell width based on container
              var containerWidth = offsetWidth || clientWidth || window.innerWidth;
              var cells = carousel.querySelectorAll('.upsell__carousel__cell');
              
              if (cells.length === 0) {
                return;
              }
              
              // Ensure carousel container has proper styles for horizontal layout
              carousel.style.overflow = 'hidden';
              carousel.style.position = 'relative';
              
              // Set cell width to container width for horizontal scrolling
              cells.forEach(function(cell, cellIndex) {
                cell.style.width = containerWidth + 'px';
                cell.style.minWidth = containerWidth + 'px';
                cell.style.display = 'block';
                cell.style.float = 'left';
                cell.style.position = 'relative';
              });
              
              // Initialize Flickity immediately - don't wait
              try {
                flkty = new Flickity(carousel, {
                  cellAlign: 'left',
                  contain: true,
                  pageDots: false,
                  prevNextButtons: false,
                  groupCells: false,
                  wrapAround: true,
                  autoPlay: 3000,
                  pauseAutoPlayOnHover: true,
                  adaptiveHeight: true,
                  percentPosition: false,
                  resize: true
                });
                
                if (flkty) {
                  attachFlickityListeners(flkty, progressBar);
                }
              } catch (initError) {
                if (attempts < 40) {
                  setTimeout(function() { waitForFlickityInit(attempts + 1); }, 100);
                }
                return;
              }
            } catch (e) {
              if (attempts < 40) {
                setTimeout(function() { waitForFlickityInit(attempts + 1); }, 100);
              }
              return;
            }
          } else {
            // If Flickity already exists, ensure autoPlay is enabled
            if (flkty.player) {
              flkty.player.stop();
            }
            flkty.option({
              autoPlay: 3000,
              pauseAutoPlayOnHover: true,
              wrapAround: true
            });
            // Restart autoPlay
            if (flkty.player) {
              flkty.player.play();
            }
          }
          if (flkty) {
            attachFlickityListeners(flkty, progressBar);
          }
        }
        function attachFlickityListeners(flkty, progressBar) {
          if (!flkty._progressBarListenersAttached) {
            function setBarToPercent(percent, animate, duration) {
              if (!progressBar) return;
              var fillBar = progressBar.querySelector('.carousel-progress-fill');
              if (!fillBar) {
                // Create fill element if it doesn't exist
                fillBar = document.createElement('div');
                fillBar.className = 'carousel-progress-fill';
                progressBar.appendChild(fillBar);
              }
              fillBar.style.transition = animate ? ('width ' + (duration/1000) + 's linear') : 'none';
              fillBar.style.width = percent + '%';
            }
            function animateFullBar() {
              if (!progressBar) return;
              var total = flkty.slides.length;
              if (total === 0) return;
              var timing = flkty.options.autoPlay || 3000;
              var totalDuration = total * timing;
              setBarToPercent(0, false);
              setTimeout(function() {
                setBarToPercent(100, true, totalDuration);
              }, 20);
            }
            function jumpToPercent(index) {
              if (!progressBar) return;
              var total = flkty.slides.length;
              if (total === 0) return;
              var percent = (index / total) * 100;
              setBarToPercent(percent, false);
            }
            flkty.on('ready', function() {
              animateFullBar();
            });
            flkty.on('change', function(index) {
              if (index === 0) {
                animateFullBar();
              }
              // Otherwise, do nothing (let the animation continue)
            });
            flkty.on('dragEnd', function() {
              jumpToPercent(flkty.selectedIndex);
            });
            flkty.on('staticClick', function() {
              jumpToPercent(flkty.selectedIndex);
            });
            flkty._progressBarListenersAttached = true;
            // Initialize progress bar animation
            setTimeout(function() {
              animateFullBar();
            }, 100);
          }
        }
        waitForFlickityInit(0);
      });
    }
  
    document.addEventListener('DOMContentLoaded', function() {
      waitForFlickityGlobal(initRelatedRecipesProgress, 0);
    });
    
    // Also try immediately if DOM is already loaded
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      waitForFlickityGlobal(initRelatedRecipesProgress, 0);
    }
  
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.matches && node.matches('.related-recipes-block, .related-recipes-block *, [data-cart-page-upsell-wrapper], [data-cart-page-upsell-wrapper] *, [data-cart-page-also-like-wrapper], [data-cart-page-also-like-wrapper] *')) {
            waitForFlickityGlobal(initRelatedRecipesProgress, 0);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  })();